import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { compose, display, margin, } from 'styled-system';
import pick from 'lodash/pick';
import { Text } from '../text';
const paddingSizes = {
    // vertical padding is 1 pixel less to make up for 1px border
    s: {
        horizontal: 8,
        vertical: 7,
    },
    m: {
        horizontal: 24,
        vertical: 11,
    },
    l: {
        horizontal: 16,
        vertical: 11,
    },
};
var PillSize;
(function (PillSize) {
    PillSize["s"] = "32px";
    PillSize["m"] = "48px";
    PillSize["l"] = "64px";
})(PillSize || (PillSize = {}));
const getColor = (theme, disabled = false) => disabled
    ? theme.pillControl.selectorColors.disabledColor
    : theme.pillControl.baseColors.color;
const RightSlotWrapper = styled.span `
  margin-left: auto;
  align-self: center;
  color: ${({ disabled, theme }) => getColor(theme, disabled)};
  & > svg {
    vertical-align: middle;
    line-height: inherit;
    color: inherit;
  }
`;
const PillControlWrapper = styled.label `
  display: block;
  border: 1px solid;
  background-color: ${({ theme }) => theme.pillControl.baseColors.bg};
  border-color: ${({ theme }) => theme.pillControl.baseColors.borderColor};
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  ${({ theme, size }) => {
    const height = PillSize[size];
    return css `
      min-height: ${height};
      border-radius: ${theme.radii.l};
      padding: ${paddingSizes[size].vertical}px
        ${paddingSizes[size].horizontal}px;
    `;
}}

  &:hover {
    background-color: ${({ theme, disabled }) => disabled
    ? theme.pillControl.baseColors.bg
    : theme.pillControl.selectorColors.hoverBackground};
  }

  ${({ isFocused }) => isFocused &&
    css `
      & input[type='radio'],
      & input[type='checkbox'] {
        outline: none;
      }
    `}
  ${compose(display, margin)}
`;
const Inner = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Left = styled.div `
  display: flex;
  align-items: center;
`;
const ControlLabel = styled(Text) `
  color: ${({ disabled, theme }) => getColor(theme, disabled)};
`;
const pickableMarginProps = [
    'm',
    'margin',
    'mt',
    'marginTop',
    'mb',
    'marginBottom',
    'ml',
    'marginLeft',
    'mr',
    'marginRight',
    'my',
    'marginY',
    'mx',
    'marginX',
];
export const PillControl = (props) => {
    const { label, size = 'm', isFocused = false, children, rightSlot, disabled, id, } = props;
    const marginProps = pick(props, pickableMarginProps);
    return (_jsx(PillControlWrapper, { ...marginProps, isFocused: isFocused, size: size, disabled: disabled, htmlFor: id, children: _jsxs(Inner, { children: [_jsxs(Left, { children: [children, _jsx(ControlLabel, { as: "span", variant: "m", marginLeft: 10, disabled: disabled, children: label })] }), _jsx(RightSlotWrapper, { disabled: disabled, children: rightSlot })] }) }));
};
//# sourceMappingURL=data:application/json;base64,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